import React from 'react';
import PropTypes from 'prop-types';
import plusIcon from 'assets/images/icons/plus.svg';
import searchIcon from 'assets/images/icons/search.svg';
import CompanyFieldActions from './CompanyFieldActions';
import FormButton from 'components/form-components/FormButton';
import TextField from 'components/form-components/TextField';
import { isPermissionAvailable } from 'config/permissionUtils';
import { permissionKeys } from 'config/config';

const CompanyFieldListHeaders = ({
  filteringData,
  setFilteringData,
  debounceFunc,
  selectedRows,
  actionsCallBack,
}) => {
  return (
    <div className='section-header d-flex justify-content-between align-items-center px-2'>
      <div className='d-flex gap-3'>
        <TextField
          value={filteringData['search'] ? filteringData['search'] : ''}
          name='search'
          handleChange={setFilteringData}
          placeholder='field_search'
          icon={searchIcon}
          debounceFunc={debounceFunc}
          shrink
        />
        <CompanyFieldActions
          ids={selectedRows}
          isActionButton={false}
          actionsCallBack={actionsCallBack}
        />
      </div>
      {isPermissionAvailable(permissionKeys.field_work_response_set_create) && (
        <FormButton
          text='button_add_new'
          variant='green-1'
          onClick={() => actionsCallBack('add', { id: null })}
          icon={plusIcon}
          iconClasses='svg-white'
        />
      )}
    </div>
  );
};

CompanyFieldListHeaders.propTypes = {
  filteringData: PropTypes.object.isRequired,
  setFilteringData: PropTypes.func.isRequired,
  debounceFunc: PropTypes.func.isRequired,
  selectedRows: PropTypes.array.isRequired,
  actionsCallBack: PropTypes.func.isRequired,
};

export default CompanyFieldListHeaders;
